export const RED = '0',
  BLUE = '1';

export const STATS = {
  [RED]: {
    name: 'Red',
    hexColor: '#ff0000',
  },
  [BLUE]: {
    name: 'Blue',
    hexColor: '#0000ff',
  },
};

export const HIGLIGHT_COLOR = 'hotpink';

export const ENTERING_SPACE = 100,
  RACK = 200,
  CAPTURED = -1;

export const MOVE_SETS = [
  [ENTERING_SPACE, 10, 6, 4, 2, 7, RACK],
  [ENTERING_SPACE, 9, 3, 1, 5, 8, RACK],
  [ENTERING_SPACE, 10, 3, 4, 2, 8, RACK],
  [ENTERING_SPACE, 11, 7, 3, 1, 8, RACK],
  [ENTERING_SPACE, 9, 6, 0, 5, 7, RACK],
  [ENTERING_SPACE, 11, 6, 0, 4, 5, RACK],
];

export const MAX_TILES_IN_ENTERING_SPACE = 3;
